<h3>Transportista</h3>
<div class="dashboard-counters">
  <ion-card>
    <ion-card-content>
      <div class="counter">{{ todayDocumentsAsCarrierCount() }}</div>
      <div class="label">Hoy</div>
    </ion-card-content>
  </ion-card>
  <ion-card>
    <ion-card-content>
      <div class="counter">{{ nextDocumentsAsCarrierCount() }}</div>
      <div class="label">Próximos días</div>
    </ion-card-content>
  </ion-card>
  <ion-card>
    <ion-card-content>
      <div class="counter">{{ pastDocumentsAsCarrierCount() }}</div>
      <div class="label">Archivados</div>
    </ion-card-content>
  </ion-card>
</div>
